import template from './debug-panel.dot';
const debugPanelTemplate = template.default ? template.default : template;
export { debugPanelTemplate };
